import affiliates from '@/api/affiliates';
import auth from '@/api/auth';
import billing from '@/api/billing';
import bootstrap from '@/api/bootstrap';
import dashboard from '@/api/dashboard';
import kiosk from '@/api/kiosk';
import notifications from '@/api/notifications';
import rewards from '@/api/rewards';
import settings from '@/api/settings';
import teams from '@/api/teams';
import user from '@/api/user';

const API = {
    affiliates: affiliates(),
    auth: auth(),
    billing: billing(),
    bootstrap: bootstrap(),
    dashboard: dashboard(),
    kiosk: kiosk(),
    notifications: notifications(),
    rewards: rewards(),
    settings: settings(),
    teams: teams(),
    user: user(),
};

export default API;
